import { AuthUser, Company, CustomerType, Location, User } from '../models'
import { RawLocation, Route, RouteConfig } from 'vue-router'
/*** Permissions ***/
import {
  locationLevelRoutesPermissions,
  paymentBetaAccessRoutes,
  routesRequiredPermissions,
} from '@/routes/permissions'

import { CUSTOM_AGENCIES_PERMISSIONS } from '../apps/saas/constants'
// import TeamSettingsPage from '@/pmd/pages/settings/TeamSettingsPage.vue';
import CalendarPage from '@/pmd/pages/CalendarPage.vue'
import ConversationProviderSettings from '@/pmd/pages/settings/ConversationProviderSettings.vue'
import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import LaunchpadMicroApp from '@/pmd/pages/LaunchpadMicroApp.vue'
// media files
import MediaSettings from '@/pmd/pages/medias/MediaSettings.vue'
import { Modules } from '../util/modules'
import PaymentsApp from '@/pmd/pages/payments/PaymentsApp.vue'
import TriggerLinks from '@/pmd/pages/links/TriggerLinks.vue'
import first from 'lodash/first'
import isEmpty from 'lodash/isEmpty'
import keys from 'lodash/keys'
import { restrictUserByAgencyPermission } from '../util/helper'
import { routePaths } from './paths'
import store from '../store'
import { CUSTOM_AGENCIES_PERMISSIONS } from '../apps/saas/constants'
import { restrictUserByAgencyPermission } from '../util/helper'
import { setupLocale } from '../bootstrap'

// ====================================================== //
const CustomMenuLinkPage = () =>
  import(
    /* webpackChunkName: "custom-menu-link" */ '@/pmd/pages/agency/CustomMenuLinkPage.vue'
  )
const CustomPagesLinkPage = () =>
  import(
    /* webpackChunkName: "custom-menu-link" */ '@/pmd/pages/agency/CustomPagesLinkPage.vue'
  )
// ========================================================== //
/*** Agency Level Settings Components: ***/
const ProfileSettings = () =>
  import(
    /* webpackChunkName: "profile-settings" */ '@/pmd/pages/settings/ProfileSettingsPage.vue'
  )
const ProfileSettingsV3 = () =>
  import(
    /* webpackChunkName: "profile-settings" */ '@/pmd/pages/settings/ProfileSettingsV3Page.vue'
  )

const ConversationAiSettings = () =>
  import(
    /* webpackChunkName: "profile-settings" */ '@/apps/conversations/settings/ai.vue'
  )

const ProfileSettingsV2 = () =>
  import('@/pmd/pages/settings/Profile.vue').then(m => m.default)

const AccountTeamManagement = () =>
  import(
    /* webpackChunkName: "team-management" */ '@/pmd/pages/agency/AccountTeamManagement.vue'
  ).then(m => m.default)
const Team = () => import('@/pmd/pages/agency/Team.vue').then(m => m.default)
const AccountTeamsManagement = () =>
  import(
    /* webpackChunkName: "team-management" */ '@/pmd/pages/agency/AccountTeamsManagement.vue'
  ).then(m => m.default)
const AccountCustomFieldsSettings = () =>
  import(
    /* webpackChunkName: "custom-fields-settings" */ '@/pmd/pages/agency/AgencyCustomFieldsSettings.vue'
  ).then(m => m.default)
const Scoring = () =>
  import(
    /* webpackChunkName: "custom-fields-settings" */ '@/pmd/pages/settings/Scoring.vue'
  ).then(m => m.default)

// ====================================================== //
/*** Report Adwords Components: ***/
const ReportingAdwordsIndex = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '../pmd/pages/reporting/adwords/ReportingAdwordsIndex.vue'
  ).then(m => m.default)
const AdwordsCampaigns = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '../pmd/pages/reporting/adwords/AdwordsCampaigns.vue'
  ).then(m => m.default)
const AdwordsAdgroups = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '../pmd/pages/reporting/adwords/AdwordsAdgroups.vue'
  ).then(m => m.default)
const AdwordsAds = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '../pmd/pages/reporting/adwords/AdwordsAds.vue'
  ).then(m => m.default)
const AdwordsKeywords = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '../pmd/pages/reporting/adwords/AdwordsKeywords.vue'
  ).then(m => m.default)
const AdwordsConversions = () =>
  import(
    /* webpackChunkName: "adwords-reporting" */ '../pmd/pages/reporting/adwords/AdwordsConversions.vue'
  ).then(m => m.default)

// ========================================================== //
/*** Location Level Components: ***/
// const SideBar = () => import("@/pmd/components/locations/LocationSideBar.vue").then(m => m.default)
const LocationParent = () =>
  import(/* webpackChunkName: "location" */ '@/pmd/pages/LocationParent.vue')

const LocationDashboardSwitcher = () =>
  import(
    /* webpackChunkName: "dashboard" */ '../pmd/pages/reporting/dashboard/LocationDashboardSwitcher.vue'
  ).then(m => m.default)

const AppointmentsPage = () =>
  import(
    /* webpackChunkName: "appointments" */ '../pmd/pages/AppointmentsPage.vue'
  ).then(m => m.default)
const AppointmentsPageNew = () =>
  import(
    /* webpackChunkName: "appointments" */ '../pmd/pages/AppointmentsPageNew.vue'
  ).then(m => m.default)

const AppointmentsReportPage = () =>
  import(
    /* webpackChunkName: "appointments-reports" */ '@/pmd/pages/AppointmentsReportPage.vue'
  ).then(m => m.default)

const NotificationsPage = () =>
  import(
    /* webpackChunkName: "notifications" */ '../pmd/pages/NotificationsPage.vue'
  ).then(m => m.default)

const NotificationsList = () =>
  import(
    /* webpackChunkName: "notification-list" */ '../pmd/pages/NotificationsList.vue'
  ).then(m => m.default)

const TikTokAdFieldsMappingSettings = () =>
  import(
    /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/TikTokAdFieldsMappingSettings.vue'
  )

const LinkedInFormsPage = () =>
  import(
    /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/integrations/linkedIn/LinkedInFormsPage.vue'
  )

const RemindersPage = () =>
  import(
    /* webpackChunkName: "reminders" */ '../pmd/pages/RemindersPage.vue'
  ).then(m => m.default)

const AffiliateManagerDashboard = () =>
  import(
    /* webpackChunkName: "affiliate-manager" */ '@/pmd/pages/AffiliateManager.vue'
  )

// const CalendarPage = () => import("@/pmd/pages/CalendarPage.vue").then(m => m.default)

const ConversationsRouter = () =>
  import(
    /* webpackChunkName: "conversations" */ '@/apps/conversations/components/v2/ConversationsRouter.vue'
  ).then(m => m.default)
// const ProfilePage = () => import("@/pmd/pages/ProfilePage.vue").then(m => m.default)
const AnalysisPage = () =>
  import(
    /* webpackChunkName: "analysis-p" */ '@/pmd/pages/AnalysisPage.vue'
  ).then(m => m.default)

const ReputationLandingPage = () =>
  import(
    /* webpackChunkName: "reputation-landing-page" */ '@/pmd/pages/reputation/ReputationLandingPage.vue'
  ).then(m => m.default)

const ReputationSetingsPage = () =>
  import(
    /* webpackChunkName: "reputation-settings-page" */ '@/pmd/pages/reputation/tabs/ReputationSettingsPage.vue'
  ).then(m => m.default)

const ReputationOnlineListing = () =>
  import(
    /* webpackChunkName: "reputation-online-listing-page" */ '@/pmd/pages/reputation/builders/OnlineListingAppBuilder.vue'
  ).then(m => m.default)

const ReputationDashboardBuilder = () =>
  import(
    /* Reputation Dashboard Remote from Reputation App */ '@/pmd/pages/reputation/builders/ReputationDashboardBuilder.vue'
  ).then(m => m.default)

const ReviewRequestsBuilder = () =>
  import(
    /* Review Requests Remote from Reputation App */ '@/pmd/pages/reputation/builders/ReviewRequestsBuilder.vue'
  ).then(m => m.default)

const ReviewsBuilder = () =>
  import(
    /* Reviews Remote from Reputation App */ '@/pmd/pages/reputation/builders/ReviewsBuilder.vue'
  ).then(m => m.default)

const WidgetsBuilder = () =>
  import(
    /* Widgets Creator Remote from Reputation App */ '@/pmd/pages/reputation/builders/WidgetsBuilder.vue'
  ).then(m => m.default)

const CallReportingUISwitcher = () =>
  import(
    /* webpackChunkName: "numberpool-dashboard" */ '@/pmd/pages/reporting/calls/CallReportingUISwitcher.vue'
  ).then(m => m.default)
const AgentReporting = () =>
  import(
    /* webpackChunkName: "agent-reporting" */ '@/pmd/pages/AgentReporting.vue'
  ).then(m => m.default)
const ManualActionList = () =>
  import(
    /* webpackChunkName: "manual-actions" */ '@/pmd/pages/ManualActionList.vue'
  ).then(m => m.default)
const SmartList = () =>
  import(
    /* webpackChunkName: "smartlist" */ '@/pmd/pages/smartlist/SmartList.vue'
  ).then(m => m.default)
const CustomerDetailNew = () =>
  import(
    /* webpackChunkName: "customer-details" */ '@/pmd/pages/customers/ContactDetailNew.vue'
  )
const OpportunitiesPage = () =>
  import(
    /* webpackChunkName: "opportunities" */ '@/pmd/pages/OpportunitiesPage.vue'
  )
const CustomerImportsPage = () =>
  import(
    /* webpackChunkName: "customer-imports" */ '@/pmd/pages/customers/ContactBulkRequests.vue'
  )

const CustomerRestore = () =>
  import('@/pmd/pages/customers/CustomerRestore.vue')

const BulkActionsPage = () =>
  import(
    /* webpackChunkName: "customer-imports" */ '@/pmd/pages/smartlist/BulkActionsList.vue'
  )
const BulkActionsView = () =>
  import(
    /* webpackChunkName: "customer-imports" */ '@/pmd/pages/smartlist/BulkActionsView.vue'
  )
// ========================================================== //
/*** Location Level Settings Components: ***/
const CustomValues = () =>
  import(
    /* webpackChunkName: "location-custom-values" */ '@/pmd/pages/settings/CustomValues.vue'
  ).then(m => m.default)

const NewCalendarSetupPage = () =>
  import(
    /* webpackChunkName: "location-custom-values" */ '@/pmd/pages/settings/NewCalendarSetupPage.vue'
  ).then(m => m.default)

const CompanySettingsPage = () =>
  import(
    /* webpackChunkName: "location-company-settings" */ '@/pmd/pages/settings/CompanySettingsPage.vue'
  ).then(m => m.default)
const LocationBillingPage = () =>
  import(
    /* webpackChunkName: "location-company-settings" */ '@/pmd/pages/settings/LocationBillingPage.vue'
  ).then(m => m.default)
const LocationBillingSettings = () =>
  import('@/pmd/pages/settings/LocationBillingSettings.vue').then(
    m => m.default
  )
const LocationWalletTransactions = () =>
  import('@/pmd/pages/settings/LocationWalletTransactions.vue').then(
    m => m.default
  )
const IntegrationSettingsPage = () =>
  import(
    /* webpackChunkName: "location-integration-settings" */ '@/pmd/pages/settings/IntegrationSettingsPage.vue'
  )
const SocialPostingSettings = () =>
  import(
    /* webpackChunkName: "location-social-settings" */ '@/pmd/pages/settings/SocialPostingSettings.vue'
  ).then(m => m.default)
const ReviewPopupSettings = () =>
  import(
    /* webpackChunkName: "location-review-settings-m" */ '@/pmd/pages/settings/ReviewPopupSettings.vue'
  ).then(m => m.default)
const PipelineSettings = () =>
  import(
    /* webpackChunkName: "location-pipeline-settings" */ '@/pmd/pages/settings/PipelineSettings.vue'
  ).then(m => m.default)
const PaymentSettings = () =>
  import(
    /* webpackChunkName: "location-payment-settings" */ '@/pmd/pages/settings/PaymentSettings.vue'
  ).then(m => m.default)
const AppointmentWidgetSettings = () =>
  import(
    /* webpackChunkName: "location-appointment-settings" */ '@/pmd/pages/settings/AppointmentWidgetSettings.vue'
  )
const ChatWidgetSettings = () =>
  import(
    /* webpackChunkName: "location-chat-settings" */ '@/pmd/pages/settings/ChatWidgetSettings.vue'
  ).then(m => m.default)
const NoShowSMSSettings = () =>
  import(
    /* webpackChunkName: "location-nosms-settings" */ '@/pmd/pages/settings/NoShowSMSSettings.vue'
  ).then(m => m.default)
const BirthdaySMSSettings = () =>
  import(
    /* webpackChunkName: "location-birthday-sms-settings" */ '@/pmd/pages/settings/BirthdaySMSSettings.vue'
  ).then(m => m.default)

const AllPhoneNumbersSettings = () =>
  import(
    /* webpackChunkName: "location-phone-number-settings" */ '@/pmd/pages/settings/AllPhoneNumbersSettings.vue'
  ).then(m => m.default)
const WhatsApp = () =>
  import(
    /* webpackChunkName: "whatsapp" */ '@/pmd/pages/settings/WhatsAppSettings.vue'
  )

const PhoneNumbersMicroApp = () =>
  import(
    /* webpackChunkName: "location-phone-number-settings" */ '@/pmd/pages/settings/PhoneNumbersMicroApp.vue'
  ).then(m => m.default)
// const BulkEmailSettings = () =>
//   import('@/pmd/pages/settings/BulkEmailSettings.vue').then(m => m.default)

const LocationMailGunSettings = () =>
  import(
    /* webpackChunkName: "location-mailgun-settings" */ '@/pmd/pages/settings/LocationMailGunSettings.vue'
  )

const CalendarSettings = () =>
  import(
    /* webpackChunkName: "location-calendar-settings" */ '@/pmd/pages/settings/CalendarSettings.vue'
  ).then(m => m.default)
const TemplateSettings = () =>
  import(
    /* webpackChunkName: "location-template-settings" */ '@/pmd/pages/settings/TemplateMessageSettings.vue'
  )
const SocialMediaDashboard = () =>
  import(
    /* webpackChunkName: "social-media-dashboard" */ '@/pmd/pages/social_media/SocialMediaDashboard.vue'
  ).then(m => m.default)
const CampaignList = () =>
  import(
    /* webpackChunkName: "m-campaign-list" */ '@/pmd/pages/marketing/CampaignList.vue'
  ).then(m => m.default)
const CampaignNew = () =>
  import(
    /* webpackChunkName: "m-campaign-new" */ '@/pmd/pages/marketing/CampaignNew.vue'
  ).then(m => m.default)
const CampaignDetail = () =>
  import(
    /* webpackChunkName: "m-campaign-detail" */ '@/pmd/pages/marketing/CampaignDetail.vue'
  ).then(m => m.default)
const CampaignActivity = () =>
  import(
    /* webpackChunkName: "m-campaign-activity" */ '@/pmd/pages/marketing/CampaignActivity.vue'
  ).then(m => m.default)
const CampaignAccountsList = () =>
  import(
    /* webpackChunkName: "m-campaign-acc-list" */ '@/pmd/pages/marketing/CampaignAccountsList.vue'
  ).then(m => m.default)
const BulkCampaignsPage = () =>
  import(
    /* webpackChunkName: "m-bulk-campaigns" */ '@/pmd/pages/marketing/BulkCampaignsPage.vue'
  ).then(m => m.default)
const FormBuilderPage = () =>
  import(
    /* webpackChunkName: "m-form-builder" */ '@/pmd/pages/marketing/FormBuilderPage.vue'
  ).then(m => m.default)
const FunnelRoot = () =>
  import('@/pmd/pages/funnels/FunnelRoot.vue').then(m => m.default)
const FunnelsPage = () =>
  import('@/pmd/pages/funnels/FunnelsPage.vue').then(m => m.default)
const WebsitesPage = () =>
  import('@/pmd/pages/funnels/WebsitesPage.vue').then(m => m.default)
const SurveyBuilderPage = () =>
  import('@/pmd/pages/marketing/SurveyBuilderPage.vue').then(m => m.default)
const FormAnalyze = () =>
  import('@/pmd/pages/marketing/FormAnalyze.vue').then(m => m.default)
const FormSubmissionPage = () =>
  import('@/pmd/pages/marketing/FormSubmissionPage.vue').then(m => m.default)
const FormSubmission = () =>
  import('@/pmd/pages/marketing/FormSubmission.vue').then(m => m.default)
const FormRoot = () =>
  import('@/pmd/pages/marketing/FormRoot.vue').then(m => m.default)
const SurveyRoot = () =>
  import('@/pmd/pages/marketing/SurveyRoot.vue').then(m => m.default)
const Emails = () => import('@/pmd/pages/emailBuilder/Emails.vue')
const TextBuilder = () =>
  import(
    /* webpackChunkName: "m-text-builder" */ '@/pmd/pages/marketing/TextTemplates.vue'
  ).then(m => m.default)

const BuilderCreateForm = () =>
  import(
    /* webpackChunkName: "m-builder-create-from" */ '@/pmd/pages/marketing/BuilderCreateForm.vue'
  ).then(m => m.default)

const BuilderCreateFormOld = () =>
  import(
    /* webpackChunkName: "m-builder-create-from-old" */ '@/pmd/pages/marketing/BuilderCreateFormOld.vue'
  ).then(m => m.default)

const EmbedBuilder = () =>
  import(
    /* webpackChunkName: "m-email-builder" */ '@/pmd/pages/marketing/EmbedBuilder.vue'
  ).then(m => m.default)

const FacebookAdFieldsMappingSettings = () =>
  import(
    /* webpackChunkName: "form-builder-mapping-settings" */ '@/pmd/pages/settings/FacebookAdFieldsMappingSettings.vue'
  )

const DomainSettings = () =>
  import(
    /* webpackChunkName: "domain-settings" */ '@/pmd/pages/settings/DomainSettings.vue'
  ).then(m => m.default)

const GhlLabs = () =>
  import(
    /* webpackChunkName: "domain-settings" */ '../pmd/pages/settings/GhlLabs/GhlLabs.vue'
  ).then(m => m.default)

const RedirectSettings = () =>
  import('@/pmd/pages/settings/RedirectSettings.vue').then(m => m.default)

const TagsSettings = () =>
  import(
    /* webpackChunkName: "tags-settings" */ '@/pmd/pages/settings/manage_tags/TagsSettings.vue'
  ).then(m => m.default)

const CustomEmailsSettings = () =>
  import(
    /* webpackChunkName: "tags-settings" */ '@/pmd/pages/settings/CustomEmailsSettings.vue'
  ).then(m => m.default)

const BusinessSettings = () =>
  import(
    /* webpackChunkName: "business-settings" */ '@/pmd/pages/settings/BusinessSettings.vue'
  ).then(m => m.default)

const SMTPServiceSettings = () =>
  import(
    /* webpackChunkName: "smpt-settings" */ '@/pmd/pages/settings/SMTPServiceSettings.vue'
  ).then(m => m.default)

const EmbedSurvey = () =>
  import(
    /* webpackChunkName: "m-embed-survey" */ '@/pmd/pages/marketing/EmbedSurvey.vue'
  ).then(m => m.default)

const SurveyList = () =>
  import(
    /* webpackChunkName: "m-survey-list" */ '@/pmd/pages/marketing/SurveyList.vue'
  ).then(m => m.default)

const SurveySubmissionPage = () =>
  import('@/pmd/pages/marketing/SurveySubmissionPage.vue').then(m => m.default)

const BuilderCreateSurvey = () =>
  import(
    /* webpackChunkName: "m-builder-create-survey" */ '@/pmd/pages/marketing/BuilderCreateSurvey.vue'
  ).then(m => m.default)

const JotboxForm = () =>
  import('@/pmd/pages/marketing/JotboxForm.vue').then(m => m.default)

const JotboxSurvey = () =>
  import('@/pmd/pages/marketing/JotboxSurvey.vue').then(m => m.default)

const FunnelsList = () =>
  import(
    /* webpackChunkName: "funnels-list" */ '@/pmd/pages/funnels/FunnelsList.vue'
  )

// import FunnelDetailPage from '@/pmd/pages/funnels/FunnelDetailPage.vue'
const FunnelDetailPage = () =>
  import(
    /* webpackChunkName: "funnel-details" */ '@/pmd/pages/funnels/FunnelDetailPage.vue'
  )
  
const FunnelSteps = () =>
  import(
    /* webpackChunkName: "funnel-steps" */ '@/pmd/pages/funnels/FunnelSteps.vue'
  )
const FunnelStats = () =>
  import(
    /* webpackChunkName: "funnel-stats" */ '@/pmd/pages/funnels/FunnelStats.vue'
  )
const FunnelSales = () =>
  import(
    /* webpackChunkName: "funnel-sales" */ '@/pmd/pages/funnels/FunnelSales.vue'
  )
const FunnelSettings = () =>
  import(
    /* webpackChunkName: "funnel-settings" */ '@/pmd/pages/funnels/FunnelSettings.vue'
  )

const WebsiteProducts = () =>
  import(
    /* webpackChunkName: "website-products" */ '@/pmd/components/funnels/WebsiteProducts.vue'
  )

const FunnelStepOverview = () =>
  import(
    /* webpackChunkName: "funnel-step-overview" */ '@/pmd/pages/funnels/FunnelStepOverview.vue'
  )
const FunnelStepAutomation = () =>
  import(
    /* webpackChunkName: "funnel-step-automation" */ '@/pmd/pages/funnels/FunnelStepAutomation.vue'
  )
const FunnelStepPublish = () =>
  import(
    /* webpackChunkName: "funnel-step-publish" */ '@/pmd/pages/funnels/FunnelStepPublish.vue'
  )
const FunnelStepProduct = () =>
  import(
    /* webpackChunkName: "funnel-step-product" */ '@/pmd/pages/funnels/FunnelStepProduct.vue'
  )

const FunnelStepProductV2 = () =>
  import(
    /* webpackChunkName: "funnel-step-product" */ '@/pmd/pages/funnels/FunnelStepProductV2.vue'
  )

const FunnelProductsList = () =>
  import('@/pmd/pages/funnels/FunnelProductsList.vue')

const TriggersPage = () =>
  import(
    /* webpackChunkName: "triggers" */ '@/pmd/pages/triggers/TriggersPage.vue'
  )

const TriggerDetailPage = () =>
  import(
    /* webpackChunkName: "trigger-detail" */ '@/pmd/pages/triggers/TriggerDetailPage.vue'
  )

const LinksPage = () =>
  import(
    /* webpackChunkName: "m-links" */ '@/pmd/pages/marketing/LinksPage.vue'
  )

const SocialMediaPostDashboard = () =>
  import(
    /* webpackChunkName: "m-links" */ '@/pmd/pages/marketing/SocialMediaPlanner.vue'
  )

const SuspendedLocation = () =>
  import(
    /* webpackChunkName: "agency-billing-inactive-location" */ '@/pmd/pages/agency/billing/SuspendedLocation.vue'
  ).then(m => m.default)

const RestrictedLocation = () =>
  import(
    /* webpackChunkName: "agency-billing-inactive-location" */ '@/pmd/pages/agency/billing/RestrictLocation.vue'
  ).then(m => m.default)

// const CalendarV2Page = () =>
//   import(/* webpackChunkName: "calendar-v2" */ '@/pmd/pages/CalendarV2Page.vue')

/*** Website-specific Components: ***/
const TemplateLibraryAdmin = () =>
  import(
    /* webpackChunkName: "template-library-admin" */ '@/pmd/pages/template_library/TemplateLibraryAdmin.vue'
  )
const WebsiteTemplateCategory = () =>
  import(
    /* webpackChunkName: "website-template-category" */ '@/pmd/pages/agency/WebsiteTemplateCategory.vue'
  )
const WebsiteTemplateCategoryList = () =>
  import(
    /* webpackChunkName: "website-template-cat-list" */ '@/pmd/pages/agency/WebsiteTemplateCategoryList.vue'
  )
const WebsiteTemplateCategoryDetail = () =>
  import(
    /* webpackChunkName: "website-template-cat-details" */ '@/pmd/pages/agency/WebsiteTemplateCategoryDetail.vue'
  )
const WebsiteTemplateDetail = () =>
  import(
    /* webpackChunkName: "website-template-details" */ '@/pmd/pages/agency/WebsiteTemplateDetail.vue'
  )

const ChooseWebsiteTemplateCategory = () =>
  import(
    /* webpackChunkName: "website-template-category-select" */ '@/pmd/pages/funnels/ChooseWebsiteTemplateCategory.vue'
  )
const ChooseWebsiteTemplateCategoryDetail = () =>
  import(
    /* webpackChunkName: "website-template-cat-details-select" */ '@/pmd/pages/funnels/ChooseWebsiteTemplateCategoryDetail.vue'
  )
const UserWebsiteTemplateDetail = () =>
  import(
    /* webpackChunkName: "user-website-template-details" */ '@/pmd/pages/funnels/UserWebsiteTemplateDetail.vue'
  )
const workflowBuilder = () =>
  import('@/pmd/pages/workflow/WorkflowMicroApp.vue')

const contentAIPage = () => import('@/pmd/pages/content_ai/ContentAIPage.vue')

const membershipBuilder = () =>
  import('@/pmd/pages/membership/MembershipMicroApp.vue')

const communitiesBuilder = () =>
  import('@/pmd/pages/communities/CommunitiesBuilder.vue')

const communitiesRoot = () =>
  import('@/pmd/pages/communities/CommunitiesRoot.vue')
const certificatesBuilder = () =>
  import('@/pmd/pages/certificates/CertificatesBuilder.vue')

const certificatesRoot = () => import('@/pmd/pages/certificates/CertificatesRoot.vue')
const clientPortalBuilder = () =>
  import('@/pmd/pages/client-portal/ClientPortalMicroApp.vue')
const membershipRoot = () => import('@/pmd/pages/membership/MembershipRoot.vue')

const membershipBuilderV2 = () =>
  import('@/pmd/pages/membership/MembershipBuilderV2.vue')

const BlogsApp = () => import('@/pmd/pages/blogs/BlogsApp.vue')

const ISVApp = () => import('@/pmd/pages/isv/ISVApp.vue')

const SaasBuilder = () =>
  import(
    /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/saas/SaasBuilder.vue'
  ).then(m => m.default)

// ========================================================== //
/*** FB Reporting Components: ***/
const ReportingFacebookIndex = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/facebook/ReportingFacebookIndex.vue'
  ).then(m => m.default)
const ReportingFacebookCampaigns = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/facebook/ReportingFacebookCampaigns.vue'
  ).then(m => m.default)
const ReportingFacebookAdsets = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/facebook/ReportingFacebookAdsets.vue'
  ).then(m => m.default)
const ReportingFacebookAds = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/facebook/ReportingFacebookAds.vue'
  ).then(m => m.default)

const ReportingFacebookDemographics = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/facebook/ReportingFacebookDemographics.vue'
  ).then(m => m.default)

const ReportingAttribution = () =>
  import(
    /* webpackChunkName: "fb-reporting" */ '@/pmd/pages/reporting/attribution/ReportingAttribution.vue'
  ).then(m => m.default)
const AttributionDashboard = () =>
  import(
    /* webpackChunkName: "attribution-reporting-v2" */ '@/pmd/pages/reporting/attribution/AttributionDashboard.vue'
  ).then(m => m.default)

const CallReportingDashboard = () =>
  import(
    /* webpackChunkName: "call-reporting-v2" */ '@/pmd/pages/reporting/calls/CallReportingDashboard.vue'
  ).then(m => m.default)
const ElizaFAQSetting = () =>
  import(
    /* webpackChunkName: "bot-faq" */ '@/pmd/pages/agency/ElizaFAQSetting.vue'
  ).then(m => m.default)
const TextWidgetSettingsPage = () =>
  import(
    /* webpackChunkName: "textWidgetSetting" */ '@/pmd/pages/settings/textWidgetSetting.vue'
  )
const PaymentsPage = () =>
  import(
    /* webpackChunkName: "Payments" */ '@/pmd/pages/payments/PaymentsPage.vue'
  )

const Products = () =>
  import(/* webpackChunkName: "Products" */ '@/pmd/pages/payments/Products.vue')

const ProductsPage = () =>
  import(
    /* webpackChunkName: "PaymentsPage" */ '@/pmd/pages/payments/ProductsPage.vue'
  )
const CreateProduct = () =>
  import(
    /* webpackChunkName: "CreateProduct" */ '@/pmd/pages/payments/CreateProduct.vue'
  )

const ImportStripeProduct = () =>
  import(
    /* webpackChunkName: "ImportStripeProduct" */ '@/pmd/pages/payments/ImportStripeProduct.vue'
  )

const ProductDetails = () =>
  import(
    /* webpackChunkName: "ProductDetails" */ '@/pmd/pages/payments/ProductDetails.vue'
  )

const Transactions = () =>
  import(
    /* webpackChunkName: "Transactions" */ '@/pmd/pages/payments/Transactions.vue'
  )
const WordpressIndexPage = () =>
  import(
    /* webpackChunkName: "wordpress-dashboard" */ '@/pmd/pages/wordpress/WordpressIndexPage.vue'
  )
const WordpressDashboard = () =>
  import(
    /* webpackChunkName: "wordpress-dashboard" */ '@/pmd/pages/wordpress/WordpressDashboard.vue'
  )
const WordpressAdvancePage = () =>
  import(
    /* webpackChunkName: "wordpress-advance" */ '@/pmd/pages/wordpress/WordpressAdvancePage.vue'
  )
const WordpressUserManagementPage = () =>
  import(
    /* webpackChunkName: "wordpress-user-management" */ '@/pmd/pages/wordpress/WordpressUserManagementPage.vue'
  )
const WordpressPluginManagementPage = () =>
  import(
    /* webpackChunkName: "wordpress-plugin-management" */ '@/pmd/pages/wordpress/WordpressPluginManagementPage.vue'
  )
const WordpressThemeManagementPage = () =>
  import(
    /* webpackChunkName: "wordpress-theme-management" */ '@/pmd/pages/wordpress/WordpressThemeManagementPage.vue'
  )
const WordpressBackupManagementPage = () =>
  import(
    /* webpackChunkName: "wordpress-backup-management" */ '@/pmd/pages/wordpress/WordpressBackupManagementPage.vue'
  )
const WordpressAnalyticsReportPage =() =>
  import(
    /* webpackChunkName: "wordpress-analytics-management" */ '@/pmd/pages/wordpress/WordpressAnalyticsReportPage.vue'
  )
const PaymentIntegration = () =>
  import('@/pmd/pages/payments/PaymentIntegration.vue')

const PaymentIntegrationCallback = () =>
  import('@/pmd/pages/payments/PaymentIntegrationCallback.vue')

const LogViewer = () => import('@/pmd/pages/payments/LogViewer.vue')

const LogsPage = () => import('@/pmd/pages/payments/LogsPage.vue')

const AuditLogs = () => import('@/pmd/pages/audit/AuditLogs.vue')
const TasksPage = () => import('@/pmd/pages/tasks/Tasks.vue')

const BusinessPage = () =>
  import('@/pmd/pages/business/components/list/BusinessList')

const ProposalsEstimationsListPage = () =>
  import('@/pmd/pages/payments/ProposalsEstimatesList.vue')

const ProposalsEstimationsTemplateListPage = () => import('@/pmd/pages/payments/ProposalsTemplateList.vue')

const NewProposalsEstimates = () => import('@/pmd/pages/payments/NewProposalsEstimates.vue')

const ProposalsTemplateBuilder = () => import('@/pmd/pages/payments/ProposalsTemplateBuilder.vue')
// media files

const Integration = () =>
  import('@/pmd/pages/agency/Integration.vue').then(m => m.default)

const PaymentSettingsWrapper = () =>
  import('@/pmd/pages/payments/settings/PaymentSettings.vue')

const PaymentReceiptSettings = () =>
  import('@/pmd/pages/payments/settings/PaymentReceiptSettings.vue')
  
const PaymentTaxSettings = () =>
  import('@/pmd/pages/payments/settings/TaxSettings.vue')
const EcommerceNotificationSettings = () =>
  import('@/pmd/pages/payments/settings/EcommerceNotificationSettings.vue')
  
// ========================================================== //
/*** Location Level Launchpad ***/
const LaunchpadMobileAppLink = () =>
  import(
    /* webpackChunkName: "LaunchpadMobileAppLink" */ '@/pmd/components/launchpad/LaunchpadMobileAppLink.vue'
  )

const MobileAppCustomiserMicroApp = () =>
  import(
    '@/pmd/pages/mobileAppCustomiser/MobileAppCustomiserMicroApp.vue'
  ).then(m => m.default)

const _requireAccessLevelAndLocation = (
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void
) => {
  store
    .dispatch('auth/get')
    .then(async (auth: AuthUser) => {
      const user = new User(await store.dispatch('user/get'))
      const company = await store.dispatch('company/get')
      if (
        CUSTOM_AGENCIES_PERMISSIONS[company?.id] &&
        user.type === User.TYPE_ACCOUNT
      ) {
        const locationId = to.params.location_id
        const location = await store.dispatch('locations/getById', locationId)
        const restrictUser = restrictUserByAgencyPermission(
          location.permissions,
          company.id,
          to.name
        )
        if (restrictUser) {
          return next({
            name: 'dashboard',
            replace: true,
            params: { location_id: locationId },
          })
        }
      }
      if (user.type === User.TYPE_ACCOUNT && user.role === User.ROLE_USER) {
        const locationId = first(keys(user.locations)) || ''
        const sidebarVersion = store.getters['sidebarv2/getVersion']
        if (sidebarVersion != 'v2') {
          return next({
            name: 'dashboard',
            replace: true,
            params: { location_id: locationId },
          })
        } else {
          return next({
            name: 'dashboard-v2',
            replace: true,
            params: { location_id: locationId },
          })
        }
      } else {
        next()
      }
    })
    .catch(err => {
      next({
        name: 'login',
        query: { url: encodeURIComponent(to.fullPath) },
        replace: true,
      })
    })
}

let firstLoad = true

const requireAuthAndLocation = (
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void
) => {
  store
    .dispatch('auth/get')
    .then(async (auth: AuthUser) => {
      const user = new User(await store.dispatch('user/get'))
      const permissions = user.permissions
      await inactiveAuth(to, from, next)

      const requiredPermission = routesRequiredPermissions[to.name]

      if (to.name == 'location-v2') {
        return next({
          name: 'dashboard-v2',
          params: to.params,
          query: to.query,
          replace: true,
        })
      }
      if (permissions[requiredPermission] === false) {
        if (to.name == 'dashboard-v2') {
          return next({
            name: 'conversations-id-v2',
            params: to.params,
            query: to.query,
            replace: true,
          })
        } else if (to.name !== 'conversations-id-v2') {
          return next({
            name: 'dashboard-v2',
            params: to.params,
            query: to.query,
            replace: true,
          })
        } else {
          return next({
            path: from.path,
            replace: true,
          })
        }
      }

      const company = await store.dispatch('company/get')
      const sidebarVersion = store.getters['sidebarv2/getVersion']
      if (
        company &&
        company.onboardingInfo.pending === true &&
        company.status !== 'active_test-agency' &&
        user &&
        user.type === 'agency'
      ) {
        return next({
          name: 'onboarding_micro_app',
          replace: true,
        })
      }
      if (!to.params.location_id) {
        if (
          company.customerType === CustomerType.AGENCY &&
          user.type === User.TYPE_AGENCY
        ) {
          if (
            company.saasSettings &&
            company.saasSettings.agency_dashboard_visible_to === 'individual'
              ? user.saasSettings && user.saasSettings.agency_dashboard_visible
              : user.role === User.ROLE_ADMIN
          ) {
            return next({ name: 'agency_dashboard', replace: true })
          } else {
            return next({ name: 'accounts_list', replace: true })
          }
        } else if (!isEmpty(user.locations)) {
          // This is an location level user who only has access to certain locations.
          const locationId = first(keys(user.locations)) || ''
          let location = await store.dispatch('locations/getById', locationId)
          if (
            location.suspended_info &&
            location.suspended_info.restricted &&
            to.name !== 'restricted_location' &&
            user.type === User.TYPE_ACCOUNT
          ) {
            return next({
              name: 'restricted_location',
              replace: true,
              params: { location_id: locationId },
            })
          }
          if (
            location.suspended_info &&
            location.suspended_info.paused &&
            to.name !== 'suspended_location' &&
            user.type === User.TYPE_ACCOUNT
          ) {
            return next({
              name: 'suspended_location',
              replace: true,
              params: { location_id: locationId },
            })
          }
          if (sidebarVersion != 'v2') {
            return next({
              name: 'dashboard',
              replace: true,
              params: { location_id: locationId },
            })
          } else {
            return next({
              name: 'dashboard-v2',
              replace: true,
              params: { location_id: locationId },
            })
          }
        } else {
          // Direct accounts will come into this case.
          const locations = await Location.fetchAllLocations()
          if (locations.length > 0) {
            return next({
              name: 'dashboard-v2',
              replace: true,
              params: { location_id: locations[0].id },
            })
          }
        }
        return
      } else {
        if (user.type === User.TYPE_ACCOUNT) {
          const availableLocations = keys(user.locations) || []
          if (availableLocations.indexOf(to.params.location_id) === -1) {
            return next({
              path: '/',
              replace: true,
            })
          }
        }
        const location = await store.dispatch(
          'locations/getById',
          to.params.location_id
        )
        const restrictUser = restrictUserByAgencyPermission(
          location.permissions,
          company.id,
          to.name
        )
        if (restrictUser) {
          return next({
            name: 'dashboard',
            replace: true,
            params: { location_id: to.params.location_id },
          })
        }
        if (sidebarVersion != 'v2') {
          return next({
            name: 'dashboard',
            replace: true,
            params: { location_id: to.params.location_id },
          })
        }
        if(location.suspended_info && !['restricted_location', 'suspended_location'].includes(to.name) &&
        user.type === User.TYPE_ACCOUNT) {
          if(location.suspended_info.restricted) {
            return next({
              name: 'restricted_location',
              replace: true,
              params: { location_id: to.params.location_id },
            })
          } else if(location.suspended_info.paused) {
            return next({
              name: 'suspended_location',
              replace: true,
              params: { location_id: to.params.location_id },
            })
          }
        }

        if (firstLoad) {
          firstLoad = false
          await store.dispatch(
            'auth/refreshFirebaseToken',
            { locationId: to.params.location_id || null, refresh: true },
            { root: true }
          )
          await Promise.all([
            store.dispatch('locations/resetCurrentLocation', {
              locationId: to.params.location_id,
            }),
            store.dispatch('users/syncAll', to.params.location_id),
            // store.dispatch('campaigns/syncAll', to.params.location_id),
            // store.dispatch('workflows/syncAll', to.params.location_id),
            store.dispatch('oauth2/syncAll', to.params.location_id),
            store.dispatch('contacts/syncAll', to.params.location_id),
            store.dispatch('calendars/syncAll', to.params.location_id),
            store.dispatch('userCalendars/syncAll', to.params.location_id),
            store.dispatch('linkedCalendars/syncAll', {
              userId: user.id,
              locationId: to.params.location_id,
            }),
            store.dispatch('teams/syncAll', to.params.location_id),

            // store.dispatch('smtpServices/syncAll', to.params.location_id),
            // store.dispatch('mailgunServices/syncAll', to.params.location_id),
            store.dispatch('stripeConnect/syncAll', to.params.location_id),
            store.dispatch('membership/syncAll', {
              locationId: to.params.location_id,
            }),
            store.dispatch('featureFlags/syncAll', to.params.location_id),
          ])
          store.dispatch('filters/syncAll', to.params.location_id)
        }

        const locationLevelPermissionKey = locationLevelRoutesPermissions[
          to.name
        ]
          ? locationLevelRoutesPermissions[to.name]
          : requiredPermission

        let locationHasPermission = true

        if (
          location.permissions &&
          location.settings?.saas_settings?.saas_mode == 'activated' &&
          location.settings?.saas_settings?.saas_plan_id
        ) {
          if (Array.isArray(locationLevelPermissionKey)) {
            const keyPermissions = locationLevelPermissionKey.filter(
              key => location.permissions[key] === true
            )
            // location has permission for any of the key in the list for route
            locationHasPermission = keyPermissions.length > 0
          } else {
            locationHasPermission =
              location.permissions[locationLevelPermissionKey] !== false
          }
        }

        if (
          !location ||
          location.company_id !== company.id ||
          location.deleted ||
          !locationHasPermission
        ) {
          if (
            location.permissions &&
            location.settings?.saas_settings?.saas_mode == 'activated' &&
            location.permissions &&
            location.settings?.saas_settings?.saas_plan_id &&
            !location.permissions[locationLevelRoutesPermissions.dashboard]
          ) {
            if (to.name === 'dashboard-v2') {
              return next({
                name: 'conversations-id-v2',
                params: to.params,
                replace: true,
              })
            } else {
              return next({
                path: from.path,
                replace: true,
              })
            }
          } else {
            return next({
              name: 'dashboard-v2',
              replace: true,
              params: { location_id: to.params.location_id },
            })
          }
        }
      }
      const allowNewPaymentsAccess = store.getters['company/isAbove97Plan']
      if (
        !allowNewPaymentsAccess &&
        paymentBetaAccessRoutes.includes(to.name)
      ) {
        return next({
          name: 'payment-integrations-v2',
          replace: true,
          params: { location_id: to.params.location_id },
        })
      }

      if (to.name === 'audit-location-v2' && user.role !== 'admin') {
        return next({
          name: 'dashboard-v2',
          replace: true,
          params: { location_id: to.params.location_id },
        })
      }
      await setupLocale(to, from)
      next()
    })
    .catch(err => {
      next({
        name: 'login',
        query: { url: encodeURIComponent(to.fullPath) },
        replace: true,
      })
    })
}

const forceLockedTimestamp = 1607990400 // 12/15/2020 @ 12:00am (UTC)

const inactiveAuth = async (
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void
) => {
  const company = await store.dispatch('company/get')
  const user = new User(await store.dispatch('user/get'))
  const lockoutSkippedTimestamp = localStorage.getItem('lockoutSkipped')

  const lockoutSkipped = lockoutSkippedTimestamp
    ? parseInt(lockoutSkippedTimestamp) + 24 * 60 * 60 * 1000 > +new Date()
    : false

  // 1. check if location-level user
  if (user.type === User.TYPE_ACCOUNT) {
    if (
      company.status &&
      company.status.includes('inactive') &&
      +new Date() > forceLockedTimestamp * 1000
    ) {
      if (to.name === 'inactive_location') {
        // to prevent infinite loop
        next()
      } else {
        next({ name: 'inactive_location', replace: true })
      }
    } else {
      // continue
      return
    }
  } else if (!lockoutSkipped) {
    // 2. Agency Level user
    // 2.1 Lock-out with `active_failed-payment` case
    if (
      company.status &&
      company.status === 'active_failed-payment' &&
      company._data &&
      company._data.date_inactivation
    ) {
      // 2.1.1 Date of inactivation must be within next 5 days.
      const msLeftForInactivation =
        company._data.date_inactivation.seconds * 1000 - +new Date()
      if (
        msLeftForInactivation > 0 &&
        msLeftForInactivation < (7 - 5) * 24 * 60 * 60 * 1000
      ) {
        // 5 days
        if (to.name === 'inactive' && to.query.type === 'failed-payment') {
          // to prevent infinite loop
          next()
        } else {
          next({
            name: 'inactive',
            replace: true,
            query: { type: 'failed-payment' },
          })
        }
      }
    }
    // 2.2 Lock-out with all other `inactive` cases
    if (company.status && company.status.includes('inactive')) {
      if (to.name === 'inactive') {
        // to prevent infinite loop
        next()
      } else {
        next({ name: 'inactive', replace: true })
      }
    } else {
      // continue
      return
    }
  }
  return
}

export const v2: RouteConfig[] = [
  {
    path: '/v2/location/:location_id',
    name: 'location-v2',
    component: LocationParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'suspended',
        name: 'suspended_location',
        component: SuspendedLocation,
        meta: {
          hideTopBar: true,
        },
      },
      {
        path: 'restricted',
        name: 'restricted_location',
        component: RestrictedLocation,
        meta: {
          hideTopBar: true,
        },
      },
      {
        path: 'verification',
        name: 'account-verification',
        component: SaasBuilder,
        meta: {
          hideSideBar: false,
        },
      },
      {
        path: 'dashboard',
        name: 'dashboard-v2',
        meta: { module: Modules.LocationDashboard },
        component: LocationDashboardSwitcher,
      },
      {
        path: 'dashboard/:dashboard_id',
        name: 'dashboard_navigate',
        meta: { module: Modules.LocationDashboard },
        component: LocationDashboardSwitcher,
      },
      {
        path: 'launchpad',
        name: 'location-launchpad-v2',
        component: LaunchpadMicroApp,
        meta: { module: Modules.Launchpad },
      },
      {
        path: 'conversations',
        name: 'conversations-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'conversations/:conversation_id?',
            name: 'conversations-id-v2',
            component: ConversationsRouter,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'manual_actions',
            name: 'manual-actions-v2',
            component: ManualActionList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'templates',
            name: 'conversations-templates-v2',
            component: TextBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'links',
            name: 'triggers-links-conversations-v2',
            component: EmptyRouterParent,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'link',
                name: 'triggers-links-link-conversations-v2',
                component: TriggerLinks,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'analyze',
                name: 'triggers-links-analyze-conversations-v2',
                component: LinksPage,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
        ],
      },
      {
        path: 'calendars',
        name: 'calendars-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'view',
            name: 'calendars-page-v2',
            component: CalendarPage,
            beforeEnter: requireAuthAndLocation,
          },
          // {
          //   path: 'appointments',
          //   name: 'appointments-v2',
          //   component: AppointmentsPage,
          //   beforeEnter: requireAuthAndLocation,
          // },
          {
            path: 'appointments',
            name: 'appointments-list',
            component: AppointmentsPageNew,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'contacts',
        name: 'contacts-v2',
        component: EmptyRouterParent,
        children: [
          {
            path: 'smart_list/:smart_list',
            name: 'smart-list-v2',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'import_filter/:import_filter',
            name: 'import_filter-v2',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'business_name/:business_name',
            name: 'business_name-v2',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'bulk',
            component: EmptyRouterParent,
            children: [
              {
                path: 'actions',
                name: 'bulk-actions-log-v2',
                component: BulkActionsView,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'detail/:contact_id',
            name: 'contact_detail-v2',
            component: CustomerDetailNew,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'restore',
            name: 'contact_restore-v2',
            component: CustomerRestore,
            beforeEnter: requireAuthAndLocation,
            meta: { module:Modules.RestoreContacts }
          },
        ],
      },
      {
        path: 'opportunities',
        name: 'opportunities-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'list',
            name: 'opportunities-list-v2',
            component: OpportunitiesPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'pipeline',
            name: 'pipeline-opportunities-v2',
            component: PipelineSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.PipelineSettings },
          },
        ],
      },
      {
        path: 'integration',
        name: 'integration-v2',
        component: Integration,
        beforeEnter: requireAuthAndLocation,
        children: [      {
            path: '*',
            name: 'integration_app_any_location',
            component: Integration,
            beforeEnter: requireAuthAndLocation,
          }],
      },
      {
        path: 'payments/products',
        name: 'payments-products-v2',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'create',
            name: 'product-create-v2',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'view/:id',
            name: 'product-details-v2',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'edit/:id',
            name: 'product-edit-v2',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'stripe/import',
            name: 'import-stripe-product-v2',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'payments/products/v1/',
        name: 'payments-products-v1',
        component: Products,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'create',
            name: 'product-create-v1',
            component: CreateProduct,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':product_id',
            name: 'product-details-v1',
            component: ProductDetails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':product_id/edit',
            name: 'product-edit-v1',
            component: CreateProduct,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'stripe/import',
            name: 'import-stripe-product-v1',
            component: ImportStripeProduct,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'payments',
        name: 'payments-v2',
        component: PaymentsPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'list',
            name: 'product-list-v2',
            component: ProductsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'transactions',
            name: 'transactions-v2',
            component: Transactions,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'integrations',
            name: 'payment-integrations-v2',
            component: PaymentIntegration,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'integrations/:integration/callback',
            name: 'payment-integrations-callback-v2',
            component: PaymentIntegrationCallback,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'payments/invoices',
        name: 'invoices-v2',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'payments/invoice/settings',
        name: 'invoice-settings',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'payments/recurring-templates',
        name: 'recurring-templates',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'payments/invoice-templates',
        name: 'invoice-templates',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'payments/proposals-estimates',
        name: 'proposals-estimates',
        component: ProposalsEstimationsListPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'settings',
            name: 'proposals-estimates-settings',
            component: ProposalsEstimationsListPage,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'payments/proposals-estimates/templates',
        name: 'proposals-estimates-templates',
        component: ProposalsEstimationsTemplateListPage,
        beforeEnter: requireAuthAndLocation,
        children: []
      },
      {
        path: 'payments/proposals-estimates/templates/edit/:id',
        name: 'proposals-estimates-template-builder',
        component: ProposalsTemplateBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [],
        meta: {
          hideSideBar: true,
          hideTopBar: true
        }
      },
      {
        path: 'payments/proposals-estimates/edit/:id',
        name: 'proposals-estimates-edit',
        component: NewProposalsEstimates,
        beforeEnter: requireAuthAndLocation,
        children: [],
        meta: {
          hideSideBar: true,
          hideTopBar: true,
        },
      },
      {
        path: 'payments/v2/taxes',
        name: 'taxes-v2',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'payments/settings',
        name: 'payment-settings',
        component: PaymentSettingsWrapper,
        beforeEnter: requireAuthAndLocation, 
        children: [
          {
            path: 'receipts',
            name: 'payment-settings-receipts',
            component: PaymentReceiptSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.Payments },
          },
          {
            path: 'taxes',
            name: 'payment-settings-taxes',
            component: PaymentTaxSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.Payments },
          },
          {
            path: 'notifications',
            name: 'payment-settings-notifications',
            component: EcommerceNotificationSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.Payments },
          },
        ],
      },
      {
        path: 'payments/v2/orders',
        name: 'orders-v2-new',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':orderId',
            name: 'order-details-v2-new',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'payments/v2/subscriptions',
        name: 'subscriptions-v2',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':id',
            name: 'subscription-details-v2',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'payments/v2/transactions',
        name: 'transactions-v2-new',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':transactionId',
            name: 'transaction-details-v2-new',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },

      {
        path: 'payments/coupons',
        name: 'coupons',
        component: PaymentsApp,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'create',
            name: 'create-coupon',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'edit/:id',
            name: 'edit-coupon',
            component: PaymentsApp,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'marketing',
        name: 'marketing-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'social-planner',
            component: EmptyRouterParent,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: '',
                name: 'social-planner-dashboard-v2',
                component: SocialMediaPostDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'list',
                name: 'social-planner-list-v2',
                component: SocialMediaPostDashboard,
                beforeEnter: requireAuthAndLocation,
                meta: {
                  hideTopBar: false,
                },
              },
              {
                path: 'post',
                name: 'social-planner-post-v2',
                component: SocialMediaPostDashboard,
                beforeEnter: requireAuthAndLocation,
                meta: {
                  hideTopBar: true,
                },
              },
              {
                path: 'post/csv/import/:id',
                name: 'social-planner-post-import-v2',
                component: SocialMediaPostDashboard,
                beforeEnter: requireAuthAndLocation,
                meta: {
                  hideTopBar: true,
                },
              },
              {
                path: 'post/:id',
                name: 'social-planner-post-edit-v2',
                component: SocialMediaPostDashboard,
                beforeEnter: requireAuthAndLocation,
                meta: {
                  hideTopBar: true,
                },
              },
              {
                path: 'planner',
                name: 'social-planner-planner-v2',
                component: SocialMediaPostDashboard,
                beforeEnter: requireAuthAndLocation,
                meta: {
                  hideTopBar: true,
                },
              },
            ],
          },
          {
            path: 'emails',
            name: 'emails_home-v2',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'all',
                name: 'emails_home-v2-templates',
                component: Emails,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'scheduled',
                name: 'emails_home-v2-campaigns',
                component: Emails,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'emails/:path',
            name: 'emails_home-v2_detail',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },

          {
            path: 'emails/detail/:path',
            name: 'emails_home-details-v2',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'templates',
            name: 'templates-v2',
            component: TextBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'links',
            name: 'triggers-links-v2',
            component: EmptyRouterParent,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'link',
                name: 'triggers-links-link-v2',
                component: TriggerLinks,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'analyze',
                name: 'triggers-links-analyze-v2',
                component: LinksPage,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'affiliate-manager',
            component: EmptyRouterParent,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: '',
                name: 'affiliate-manager-v2',
                redirect: 'campaigns',
              },
              {
                path: 'campaigns',
                name: 'affiliate-manager-campaign-page-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'campaigns/create',
                name: 'campaign-create-page-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'campaigns/:id',
                name: 'campaign-edit-page-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'affiliates',
                name: 'affiliate-manager-affiliates-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'affiliates/:id',
                name: 'affiliate-manager-affiliates-details-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'payouts',
                name: 'affiliate-manager-payouts-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'media',
                name: 'affiliate-manager-media-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'settings',
                name: 'affiliate-manager-settings-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'media/folder/:folderId',
                name: 'affiliate-manager-media-folder-v2',
                component: AffiliateManagerDashboard,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
        ],
      },
      {
        path: 'automation',
        name: 'automation-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'new-workflow',
            component: workflowBuilder,
            name: 'newWorkflows-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'workflows',
            name: 'workflows-v2',
            component: workflowBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'content-ai',
            name: 'content-ai-v2',
            component: contentAIPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns',
            name: 'campaigns-v2',
            component: CampaignList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns/:campaign_id',
            name: 'campaign_edit-v2',
            component: CampaignNew,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns/:campaign_id/detail',
            name: 'campaign_detail-v2',
            component: CampaignDetail,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns/:campaign_id/list',
            name: 'campaign_accounts_list-v2',
            component: CampaignAccountsList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns/activity',
            name: 'campaign_activity-v2',
            component: CampaignActivity,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'bulk',
            name: 'bulk_requests-v2',
            component: BulkCampaignsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'triggers',
            name: 'triggers-v2',
            component: TriggersPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'triggers/:trigger_id',
            name: 'triggers_detail-v2',
            component: TriggerDetailPage,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'funnels-websites/client-portal',
        component: clientPortalBuilder,
        children: [
          {
            path: 'domain-setup',
            name: 'clientportal-domain-setup',
            component: clientPortalBuilder,
          },
          {
            path: 'branding',
            name: 'branding',
            component: clientPortalBuilder,
          },
          {
            path: 'settings',
            name: 'clientportal-settings',
            component: clientPortalBuilder,
          },
          {
            path: 'dashboard',
            name: 'clientportal-dashboard',
            component: clientPortalBuilder,
          },
        ],
      },
      {
        path: 'funnels-websites',
        name: 'funnels-v2',
        component: FunnelRoot,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'funnels',
            name: 'funnels-page-v2',
            component: FunnelsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'websites',
            name: 'websites-funnels-v2',
            component: WebsitesPage,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      // {
      //   path: 'funnels-websites',
      //   name: 'funnels-v2',
      //   component: FunnelsPage,
      //   beforeEnter: requireAuthAndLocation,
      //   children: [
      //     {
      //       path: 'funnels',
      //       name: 'funnels-page-v2',
      //       component: FunnelsList,
      //       beforeEnter: requireAuthAndLocation,
      //     },
      //     {
      //       path: 'websites',
      //       name: 'websites-funnels-v2',
      //       component: FunnelsList,
      //       beforeEnter: requireAuthAndLocation,
      //     },
      //     {
      //       path: 'favorites',
      //       name: 'fav_funnels-v2',
      //       component: FunnelsList,
      //       beforeEnter: requireAuthAndLocation,
      //     },
      //     {
      //       path: 'recent',
      //       name: 'recent_funnels-v2',
      //       component: FunnelsList,
      //       beforeEnter: requireAuthAndLocation,
      //     },
      //     {
      //       path: 'archived',
      //       name: 'archived_funnels-v2',
      //       component: FunnelsList,
      //       beforeEnter: requireAuthAndLocation,
      //     },
      //   ]
      // },
      {
        path: 'funnels-websites/funnels/:funnel_id',
        name: 'funnels-detail-v2',
        component: FunnelDetailPage,
        beforeEnter: requireAuthAndLocation,
        // Child route components are handled in micro frontend app
        children: [
          {
            path: 'steps/:step_id?',
            name: 'funnel-steps-v2',
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'overview',
                name: 'funnel-step-overview-v2',
              },
              {
                path: 'automation',
                name: 'funnel-step-automation-v2',
                component: FunnelStepAutomation,
              },
              {
                path: 'publish',
                name: 'funnel-step-publish-v2',
              },
              {
                path: 'product',
                name: 'funnel-step-product-v2',
              },
              {
                path: 'products',
                name: 'funnel-step-products-v2',
              },
              {
                path: 'products/create',
                name: 'funnel-step-product-v2-create',
              },
              {
                path: 'products/:funnel_product_id',
                name: 'funnel-step-product-v2-edit',
              },
            ],
          },
          {
            path: 'stats',
            name: 'funnel-stats-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'sales',
            name: 'funnel-sales-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings',
            name: 'funnel-settings-v2',
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'funnels-websites/funnels/funnel-templates',
        name: 'funnel-templates-category',
        component: ChooseWebsiteTemplateCategory,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/funnels/funnel-templates/:id',
        name: 'funnel-templates-category-detail',
        component: ChooseWebsiteTemplateCategoryDetail,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path:
          'funnels-websites/funnels/funnel-templates/:id/templates/:template_id',
        name: 'funnel-templates-detail',
        component: UserWebsiteTemplateDetail,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/websites/:funnel_id',
        name: 'websites-detail-v2',
        component: FunnelDetailPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'pages/:step_id?',
            name: 'website-pages-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'stats',
            name: 'website-stats-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'sales',
            name: 'website-sales-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings',
            name: 'website-settings-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'products/:step_id',
            name: 'website-products-v2',
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'website-products/:step_id',
            name: 'website-step-products-v2',
          },
          {
            path: 'products/create',
            name: 'website-step-product-v2',
          },
          {
            path: 'products/:funnel_product_id',
            name: 'website-step-product-v2-edit',
          },
        ],
      },
      {
        path: 'funnels-websites/websites/website-templates',
        name: 'website-templates-category',
        component: ChooseWebsiteTemplateCategory,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/websites/website-templates/:id',
        name: 'website-templates-category-detail',
        component: ChooseWebsiteTemplateCategoryDetail,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path:
          'funnels-websites/websites/website-templates/:id/templates/:template_id',
        name: 'website-templates-detail',
        component: UserWebsiteTemplateDetail,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/wordpress',
        name: 'wordpress-v2',
        component: WordpressIndexPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            name: 'wordpress_dashboard-v2',
            path: 'wordpress_dashboard-v2',
            component: WordpressDashboard,
          },
          {
            name: 'wordpress_advance-v2',
            path: 'wordpress_advance-v2',
            component: WordpressAdvancePage,
          },
          {
            name: 'wordpress_user_management-v2',
            path: 'wordpress_user_management-v2',
            component: WordpressUserManagementPage,
          },
          {
            name: 'wordpress_plugin_management-v2',
            path: 'wordpress_plugin_management-v2',
            component: WordpressPluginManagementPage,
          },
          {
            name: 'wordpress_theme_management-v2',
            path: 'wordpress_theme_management-v2',
            component: WordpressThemeManagementPage,
          },
          {
            name: 'wordpress_backup_management-v2',
            path: 'wordpress_backup_management-v2',
            component: WordpressBackupManagementPage,
          },
          {
            name: 'wordpress_analytics_report-v2',
            path: 'wordpress_analytics_report-v2',
            component: WordpressAnalyticsReportPage,
          },
        ],
      },
      {
        path: 'form-builder',
        name: 'form-builder-v2',
        component: FormRoot,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'main',
            name: 'form-builder-main-v2',
            component: FormBuilderPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'analyze',
            name: 'form-builder-analyze-v2',
            component: FormAnalyze,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'submissions',
            name: 'form-builder-submissions-v2',
            component: FormSubmissionPage,
            beforeEnter: (to, from, next) => {
              requireAuthAndLocation(to, from, () => {
                sessionStorage.removeItem('store')
                next()
              })
            },
          },
        ],
      },
      {
        path: 'funnels-websites/form-builder/jotform/:builder_id',
        name: 'jotbox_form-v2',
        component: JotboxForm,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/survey-builder/jotformsurvey/:survey_id',
        name: 'jotbox_survey-v2',
        component: JotboxSurvey,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'form-builder/:builder_id',
        name: 'form-builder-manage',
        component: BuilderCreateForm,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/form-builder/formold/:builder_id',
        name: 'form_builder_manage_old-v2',
        component: BuilderCreateFormOld,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'form-builder/:builder_id?/integrate',
        name: 'form_builder_integrate-v2',
        component: EmbedBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'survey-builder',
        name: 'survey-builder-v2',
        component: SurveyRoot,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'main',
            name: 'survey-builder-main-v2',
            component: SurveyBuilderPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'analyze',
            name: 'survey-builder-analyze-v2',
            component: SurveyList,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'submissions',
            name: 'survey-builder-submissions-v2',
            component: SurveySubmissionPage,
            beforeEnter: (to, from, next) => {
              requireAuthAndLocation(to, from, () => {
                sessionStorage.removeItem('store')
                next()
              })
            },
          },
        ],
      },
      {
        path: 'survey-builder/:survey_id',
        name: 'survey-manage',
        component: BuilderCreateSurvey,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'survey-builder/:survey_id?/integrate',
        name: 'survey_integrate-v2',
        component: EmbedSurvey,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/chat_widget_settings',
        name: 'chat-widget-settings-v2',
        component: TextWidgetSettingsPage,
        beforeEnter: requireAuthAndLocation,
        meta: { module: Modules.ChatWidgetBuilder },
      },
      {
        path: 'memberships/courses',
        component: membershipRoot,
        name: 'membership-v2',
        children: [
          {
            path: 'dashboard',
            name: 'membership-dashboard-v2',
            component: membershipBuilder,
          },
          {
            path: 'product_blueprints',
            name: 'product_blueprints-v2',
            component: membershipBuilder,
          },
          {
            path: 'products/:product_id/certificates',
            name: 'product-certificates',
            component: membershipBuilderV2,
          },
          {
            path: 'products',
            component: membershipBuilder,
            children: [
              {
                path: '/',
                name: 'membership-products-v2',
                component: membershipBuilder,
              },
              {
                path: 'library-order',
                name: 'membership-library-order-v2',
                component: membershipBuilder,
              },
              {
                path: ':id*',
                name: 'membership-product-overview-v2',
                component: membershipBuilder,
              },
              {
                path: ':id/edit',
                name: 'membership-product-edit-v2',
                component: membershipBuilder,
              },
              {
                path: ':id/offers',
                name: 'membership-product-offers',
                component: membershipBuilder,
              },
              {
                path: ':id/comments',
                name: 'membership-product-comments',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'offers/',
            name: 'membership-offers-v2',
            component: membershipBuilder,
            children: [
              {
                path: ':id*',
                name: 'membership-offer-detail-v2',
                component: membershipBuilder,
              },
              {
                path: ':id/checkout/edit',
                name: 'courses-offer-customization-v2',
                component: membershipBuilder,
              },
              {
                path: ':id/edit',
                name: 'membership-offer-edit-v2',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'analytics',
            name: 'membership-analytics-v2',
            component: membershipBuilder,
            children: [
              {
                path: 'product-progress',
                name: 'membership-product-progress-v2',
                component: membershipBuilder,
                children: [
                  {
                    path: ':id*',
                    name: 'member-progress-v2',
                    component: membershipBuilder,
                  },
                ],
              },
              {
                path: 'analytics-assessments',
                name: 'membership-analytics-assessments-v2',
                component: membershipBuilder,
                children: [
                  {
                    path: ':assessment_submission_id*',
                    name: 'membership-analytics-assessment-submission-v2',
                    component: membershipBuilder,
                  },
                ],
              },
            ],
          },
          {
            path: 'create-offers',
            name: 'offers-v2',
            component: membershipBuilderV2,
          },
          {
            path: 'offers-list',
            name: 'offers-overview-v2',
            component: membershipBuilderV2,
          },
          {
            path: 'netrevenue-analytics',
            name: 'membership-netrevenue-analytics',
            component: membershipBuilderV2,
          },
          {
            path: 'members-analytics',
            name: 'membership-members-analytics',
            component: membershipBuilderV2,
          },
          {
            path: 'member-progress/:contact_id',
            name: 'membership-members-progress',
            component: membershipBuilderV2,
          },
          {
            path: 'settings',
            name: 'membership-settings-v2',
            component: membershipBuilder,
            children: [
              {
                path: 'site-details',
                name: 'membership-site-details-v2',
                component: membershipBuilder,
              },
              {
                path: 'custom-domain',
                name: 'membership-custom-domain-v2',
                component: membershipBuilder,
              },
              {
                path: 'email-settings',
                name: 'membership-email-settings-v2',
                component: membershipBuilder,
              },
              {
                path: 'app-settings',
                name: 'membership-app-settings-v2',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'categories',
            name: 'membership-categories-v2',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                name: 'membership-category-edit',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'posts',
            name: 'membership-posts-v2',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                name: 'membership-post-edit',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'themes',
            name: 'membership-themes-v2',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                name: 'membership-edit-themes-v2',
                component: membershipBuilder,
              },
            ],
          },
          {
            path: 'themes-v2',
            name: 'membership-themes-new-v2',
            component: membershipBuilder,
            children: [
              {
                path: '*',
                name: 'membership-edit-themes-new-v2',
                component: membershipBuilder,
              },
              {
                path: ':id',
                name: 'membership-product-all-themes',
                component: membershipBuilder,
              },
            ],
          },
        ],
      },
      {
        path: 'memberships/certificates',
        component: certificatesRoot,
        name: 'certificates',
        children: [
          {
            path: 'create-certificates',
            name: 'create-certificates',
            component: certificatesBuilder,
          },
          {
            path: ':certificate_id/edit',
            name: 'edit-certificates',
            component: certificatesBuilder,
          },
        ],
      },
      {
        path: 'memberships/communities',
        component: communitiesRoot,
        name: 'communities',
        children: [
          {
            path: 'community-groups',
            name: 'community-groups',
            component: communitiesBuilder,
          },
          {
            path: 'create-group',
            name: 'create-group',
            component: communitiesBuilder,
          },
        ],
      },
      {
        path: 'memberships/communities/clientportal-domain-setup',
        name: 'communities-domain-setup',
        component: clientPortalBuilder,
      },
      {
        path: 'reputation',
        name: 'reputation-v2',
        component: ReputationLandingPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'overview',
            name: 'reputation-overview-v2',
            meta: { module: Modules.Reputation },
            beforeEnter: requireAuthAndLocation,
            component: ReputationDashboardBuilder,
          },
          {
            path: 'requests',
            name: 'reputation-review-requests-v2',
            meta: { module: Modules.Reputation },
            beforeEnter: requireAuthAndLocation,
            component: ReviewRequestsBuilder,
          },
          {
            path: 'reviews/:review_id?',
            name: 'reputation-reviews-v2',
            meta: { module: Modules.Reputation },
            beforeEnter: requireAuthAndLocation,
            component: ReviewsBuilder,
          },
          {
            path: 'widget',
            name: 'reputation-widget-v2',
            meta: { module: Modules.Reputation },
            beforeEnter: requireAuthAndLocation,
            component: WidgetsBuilder,
          },
        ],
      },
      {
        path: 'reputation/analysis',
        name: 'analysis-v2',
        component: AnalysisPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'reputation/listing',
        name: 'reputation_listing-v2',
        meta: { module: Modules.Yext },
        beforeEnter: requireAuthAndLocation,
        component: ReputationOnlineListing,
      },
      {
        path: 'reporting',
        name: 'reporting-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'google',
            name: 'reporting-google-v2',
            component: ReportingAdwordsIndex,
            meta: {
              module: Modules.AdReporting,
            },
            children: [],
          },
          {
            path: 'facebook',
            name: 'reporting-facebook-v2',
            component: ReportingFacebookIndex,
            children: [],
            meta: {
              module: Modules.AdReporting,
            },
            children: [],
          },
          {
            path: 'attribution/:type?',
            name: 'reporting-attribution-v2',
            component: ReportingAttribution,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'appointments-reports',
            name: 'appointments-reports-v2',
            component: AppointmentsReportPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'call_stats',
            name: 'call-stats-v2',
            component: CallReportingUISwitcher,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'agent_reporting',
            name: 'agent-reporting-v2',
            component: AgentReporting,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.AgentReporting },
          },
          {
            path: 'attribution-v2',
            name: 'attribution-v2',
            component: AttributionDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'call-reporting-v2',
            name: 'call-reporting-v2',
            component: CallReportingDashboard,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'mobile_app',
        name: 'location-mobile-app',
        component: MobileAppCustomiserMicroApp,
        beforeEnter: requireAuthAndLocation,
        children: [],
      },
      {
        path: 'custom-menu-link/:id',
        name: 'location-custom-menu-link-v2',
        component: CustomMenuLinkPage,
      },
      {
        path: 'custom-page-link/:id',
        name: 'location-custom-page-link-v2',
        component: CustomPagesLinkPage,
      },
      {
        path: 'settings',
        name: 'settings-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'audit/logs',
            name: 'audit-location-v2',
            component: AuditLogs,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings-profile',
            name: 'settings-profile-v2',
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'profile',
            name: 'profile-v2',
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'scoring',
            name: 'scoring',
            component: Scoring,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'conversation-ai',
            name: 'conversation-ai-settings',
            component: ConversationAiSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'company',
            name: 'company-settings-v2',
            component: CompanySettingsPage,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'conversation_providers',
            name: 'conversation_providers',
            component: ConversationProviderSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'company-billing',
            name: 'location-company-billing',
            beforeEnter: requireAuthAndLocation,
            component: LocationBillingPage,
            children: [
              {
                path: 'billing',
                name: 'location_billing-v2',
                component: LocationBillingSettings,
              },
              {
                path: 'transactions',
                name: 'location_wallet_transactions-v2',
                component: LocationWalletTransactions,
              },
            ],
          },
          {
            path: 'noshow_sms',
            name: 'no_show_sms_settings-v2',
            component: NoShowSMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'birthday_sms',
            name: 'birthday_sms_settings-v2',
            component: BirthdaySMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'social_posting',
            name: 'social_posting-v2',
            component: SocialPostingSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'review_widgets',
            name: 'review_widgets-v2',
            redirect: 'reputation/settings',
          },
          {
            path: 'review_popup',
            name: 'review_popup-v2',
            component: ReviewPopupSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'reputation',
            component: ReputationLandingPage,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'settings',
                name: 'settings-reputation-v2',
                meta: { module: Modules.Reputation },
                component: ReputationSetingsPage,
              },
            ],
          },
          {
            path: 'integrations',
            name: 'integrations-v2',
            component: EmptyRouterParent,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'list',
                name: 'integrations-settings-v2',
                component: IntegrationSettingsPage,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'facebook',
                name: 'facebook_settings-v2',
                component: FacebookAdFieldsMappingSettings,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'tiktok',
                name: 'tiktok_settings-v2',
                component: TikTokAdFieldsMappingSettings,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'linkedin',
                name: 'linkedin_settings-v2',
                component: LinkedInFormsPage,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'pipeline',
            name: 'pipeline-settings-v2',
            component: PipelineSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.PipelineSettings },
          },
          {
            path: 'payment',
            name: 'payment_settings-v2',
            component: PaymentSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'chat_widget',
            name: 'chat_widget-v2',
            component: ChatWidgetSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.ChatWidgetBuilder },
          },
          {
            path: 'appointment_widget',
            name: 'appointment-widget-2',
            component: AppointmentWidgetSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'phone_number',
            name: 'phone-number-v2',
            component: AllPhoneNumbersSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'whatsapp',
            name: 'whatsapp-v1',
            component: WhatsApp,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'templates',
            name: 'template-settings-v2',
            component: TemplateSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'staff',
            name: 'staff',
            component: EmptyRouterParent,
            beforeEnter: _requireAccessLevelAndLocation,
            children: [
              {
                path: 'teams',
                name: 'teams-v2',
                component: AccountTeamsManagement,
                beforeEnter: _requireAccessLevelAndLocation,
              },
              {
                path: 'team',
                name: 'team-v2',
                component: Team,
                beforeEnter: _requireAccessLevelAndLocation,
              },
            ],
          },
          {
            path: 'smart_list/Settings',
            name: 'smart-list-settings-v2',
            component: SmartList,
            beforeEnter: requireAuthAndLocation,
          },
          // {
          //   path: 'custom_fields',
          //   name: 'custom-fields-v2',
          //   component: EmptyRouterParent,
          //   beforeEnter: requireAuthAndLocation,
          //   children: [
          //     {
          //       path: 'fields',
          //       name: 'custom-fields-settings-v2',
          //       component: AccountCustomFieldsSettings,
          //       beforeEnter: requireAuthAndLocation,
          //     },
          //     {
          //       path: 'tags',
          //       name: 'tags-settings-v2',
          //       component: TagsSettings,
          //       beforeEnter: requireAuthAndLocation,
          //     },
          //   ]
          // },
          {
            path: 'fields',
            name: 'custom-fields-settings-v2',
            component: AccountCustomFieldsSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.CustomField },
          },
          {
            path: 'tags',
            name: 'tags-settings-v2',
            component: TagsSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'custom_emails',
            name: 'custom-emails-settings-v2',
            component: CustomEmailsSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'businesses',
            name: 'business-settings-v2',
            component: BusinessSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { module: Modules.BusinessSettings },
          },
          {
            path: 'custom_values',
            name: 'custom-values-settings-v2',
            component: CustomValues,
            beforeEnter: requireAuthAndLocation,
          },

          {
            path: 'calendars',
            component: NewCalendarSetupPage,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: '/',
                name: 'calendar-settings__default',
                component: NewCalendarSetupPage,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'preferences',
                name: 'calendar-settings__preferences',
                component: NewCalendarSetupPage,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'availability',
                name: 'calendar-settings__availability',
                component: NewCalendarSetupPage,
                beforeEnter: requireAuthAndLocation,
              },
              {
                path: 'connections',
                name: 'calendar-settings__connections',
                component: NewCalendarSetupPage,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },

          // {
          //   path: 'calendars/preferences',
          //   name: 'calendar-settings__preferences',
          //   component: NewCalendarSetupPage,
          //   beforeEnter: _requireAccessLevelAndLocation,
          // },

          {
            path: routePaths.smtpServices,
            name: 'smtp-service-v2',
            beforeEnter: requireAuthAndLocation,
            component: ISVApp,
          },
          {
            path: routePaths.emailServicesDedicatedDomains,
            name: 'location-dedicated-domain',
            beforeEnter: requireAuthAndLocation,
            component: ISVApp,
          },
          {
            path: routePaths.emailServicesAddDomain,
            name: 'location-add-domain',
            beforeEnter: requireAuthAndLocation,
            component: ISVApp,
          },
          {
            path: routePaths.emailServicesVerifyDomain,
            name: 'location-verify-domain',
            beforeEnter: requireAuthAndLocation,
            component: ISVApp,
          },
          // {
          //   path: 'smtp_service',
          //   name: 'smtp-service-v2',
          //   component: SMTPServiceSettings,
          //   beforeEnter: requireAuthAndLocation,
          // },
          // {
          //   path: 'smtp_service',
          //   name: 'smtp-service-v2',
          //   component: SMTPServiceSettings,
          //   beforeEnter: requireAuthAndLocation,
          // },
          {
            path: 'media-settings',
            name: 'media-settings-v2',
            component: MediaSettings,
            beforeEnter: requireAuthAndLocation,
            meta: {
              router_version: 'v2',
            },
          },
          {
            path: 'domain',
            name: 'domain-settings-v2',
            component: DomainSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'redirect',
            name: 'redirect-settings-v2',
            component: RedirectSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'eliza_faq',
            name: 'eliza-faq-v2',
            component: ElizaFAQSetting,
            beforeEnter: async (to, from, next) => {
              const location = await Location.getById(to.params.location_id)
              store
                .dispatch('auth/get')
                .then((auth: AuthUser) => {
                  if (location && !location.botService)
                    next({
                      name: 'dashboard-v2',
                      replace: true,
                      params: { location_id: to.params.location_id },
                    })
                  next()
                })
                .catch(err => {
                  next()
                })
            },
          },
          {
            path: 'labs',
            name: 'labs',
            component: GhlLabs,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'logs',
        name: 'log-viewer-v2',
        component: LogsPage,
        beforeEnter: requireAuthAndLocation,
        props: route => {
          status: route.query.status
        },
      },
      {
        path: 'logs/:request_id',
        name: 'log-viewer-detail-v2',
        component: LogViewer,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'notifications/:notification_id?',
        name: 'notifications-v2',
        component: NotificationsPage,
      },
      {
        path: 'notificationslist',
        name: 'notificationslist-v2',
        component: NotificationsList,
      },
      {
        path: 'reminders',
        name: 'reminders-v2',
        component: RemindersPage,
      },
      {
        path: 'social_media',
        name: 'social_media-v2',
        component: SocialMediaDashboard,
      },
      {
        path: 'tasks',
        name: 'tasks-v2',
        component: TasksPage,
        meta: { module: Modules.Task },
      },
      {
        path: 'businesses/:business_id?',
        name: 'business-v2',
        component: BusinessPage,
        meta: { module: Modules.Business },
      },
      {
        path: routePaths.blogs,
        name: 'blogs-list',
        component: BlogsApp,
        beforeEnter: requireAuthAndLocation,
        meta: { module: Modules.Blogs },
      },
      {
        path: routePaths.blogsSettings,
        name: 'blogs-settings',
        component: BlogsApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: true,
          module: Modules.Blogs,
        },
      },
      {
        path: routePaths.blogsPostEdit,
        name: 'blogs-post-edit',
        component: BlogsApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideSideBar: true,
          hideTopBar: true,
          module: Modules.Blogs,
        },
      },
      {
        path: routePaths.blogsPostSettings,
        name: 'blogs-post-settings',
        component: BlogsApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideSideBar: true,
          hideTopBar: true,
          module: Modules.Blogs,
        },
      },
      {
        path: routePaths.blogsPostPreview,
        name: 'blogs-post-preview',
        component: BlogsApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideSideBar: true,
          hideTopBar: true,
          module: Modules.Blogs,
        },
      },
      {
        path: routePaths.blogsPostVersions,
        name: 'blogs-post-history',
        component: BlogsApp,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideSideBar: true,
          hideTopBar: true,
          module: Modules.Blogs,
        },
      },
      {
        path: routePaths.blogsInvaliRoutes.blogsAuthors,
        name: 'blogs-authors',
        redirect: routePaths.blogsSettings,
      },
      {
        path: routePaths.blogsInvaliRoutes.blogsAuthorsEdit,
        name: 'blogs-authors-edit',
        redirect: routePaths.blogsSettings,
      },
      {
        path: routePaths.blogsInvaliRoutes.blogsCategories,
        name: 'blogs-categories',
        redirect: routePaths.blogsSettings,
      },
      {
        path: routePaths.blogsInvaliRoutes.blogsCategoriesEdit,
        name: 'blogs-categories-edit',
        redirect: routePaths.blogsSettings,
      },
      {
        path: routePaths.blogsInvaliRoutes.blogPost,
        name: 'blogs-post',
        redirect: routePaths.blogs,
      },
      {
        path: routePaths.blogsInvaliRoutes.blogPostWithId,
        name: 'blogs-post-id',
        redirect: routePaths.blogsPostEdit,
      },
      {
        path: 'blogs/*',
        redirect: routePaths.blogs,
      },
    ],
  },
]
